/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Walkthrough_P3_Trail_End_NoteInputs */

const en_subscription_walkthrough_p3_trail_end_note = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_End_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account is charged. Cancel anytime in the 24h before.`)
};

const ar_subscription_walkthrough_p3_trail_end_note = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_End_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم شحن الحساب. قم بالإلغاء في أي وقت خلال 24 ساعة قبلها.`)
};

const de_subscription_walkthrough_p3_trail_end_note = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_End_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Konto wird belastet. Sie können jederzeit innerhalb von 24 Stunden stornieren.`)
};

const es_subscription_walkthrough_p3_trail_end_note = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_End_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se cargará en tu cuenta. Cancela en cualquier momento durante las 24 h previas.`)
};

const fr_subscription_walkthrough_p3_trail_end_note = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_End_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre compte est débité. Annulez à tout moment avant les 24 dernières heures précédent la date de fin.`)
};

const it_subscription_walkthrough_p3_trail_end_note = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_End_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo conto è stato addebitato. Annulla in qualsiasi momento nelle 24 ore precedenti.`)
};

const ja_subscription_walkthrough_p3_trail_end_note = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_End_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントに請求されます。24時間前であればいつでもキャンセル可能です。`)
};

const ko_subscription_walkthrough_p3_trail_end_note = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_End_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정에 요금이 청구되었어요. 24시간 전에 언제든지 취소할 수 있어요.`)
};

const pt_br_subscription_walkthrough_p3_trail_end_note = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_End_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua conta é cobrada. Cancele a qualquer momento nas 24h antecedentes.`)
};

const ru_subscription_walkthrough_p3_trail_end_note = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_End_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`С вашего аккаунта списывается сумма. Отписывайтесь в любой момент за 24 часа до окончания.`)
};

const th_subscription_walkthrough_p3_trail_end_note = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_End_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บัญชีของคุณถูกเรียกเก็บเงิน ยกเลิกได้ตลอดเวลาภายใน 24 ชั่วโมงล่วงหน้า`)
};

const tr_subscription_walkthrough_p3_trail_end_note = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_End_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesabından ödeme alındı. İstediğin zaman 24 saat içinde iptal et.`)
};

const zh_cn_subscription_walkthrough_p3_trail_end_note = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_End_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`续订扣款日，提前 24 小时取消则不产生费用`)
};

const zh_tw_subscription_walkthrough_p3_trail_end_note = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_End_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`續訂扣款日，提前 24 小時取消則不產生費用`)
};

/**
* | output |
* | --- |
* | "Your account is charged. Cancel anytime in the 24h before." |
*
* @param {Subscription_Walkthrough_P3_Trail_End_NoteInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_walkthrough_p3_trail_end_note = /** @type {((inputs?: Subscription_Walkthrough_P3_Trail_End_NoteInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Walkthrough_P3_Trail_End_NoteInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_walkthrough_p3_trail_end_note(inputs)
	if (locale === "ar") return ar_subscription_walkthrough_p3_trail_end_note(inputs)
	if (locale === "de") return de_subscription_walkthrough_p3_trail_end_note(inputs)
	if (locale === "es") return es_subscription_walkthrough_p3_trail_end_note(inputs)
	if (locale === "fr") return fr_subscription_walkthrough_p3_trail_end_note(inputs)
	if (locale === "it") return it_subscription_walkthrough_p3_trail_end_note(inputs)
	if (locale === "ja") return ja_subscription_walkthrough_p3_trail_end_note(inputs)
	if (locale === "ko") return ko_subscription_walkthrough_p3_trail_end_note(inputs)
	if (locale === "pt_br") return pt_br_subscription_walkthrough_p3_trail_end_note(inputs)
	if (locale === "ru") return ru_subscription_walkthrough_p3_trail_end_note(inputs)
	if (locale === "th") return th_subscription_walkthrough_p3_trail_end_note(inputs)
	if (locale === "tr") return tr_subscription_walkthrough_p3_trail_end_note(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_walkthrough_p3_trail_end_note(inputs)
	return zh_tw_subscription_walkthrough_p3_trail_end_note(inputs)
});